var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"multiline",style:(_vm.clip),attrs:{"id":_vm.uniqueId}},[_vm._t("default")],2),(_vm.showMoreEnabled)?_c('span',{staticClass:"more",on:{"click":_vm.toggleShowMore}},[_vm._v("..."+_vm._s(_vm.showMoreText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }